export default __webpack_public_path__ + "static/media/norwaygo-screenshot-01.e90f4ff6.png";